/** Is the employee record on screen the signed-in user's own?
 *
 *  Employee rows key on the AUTH user id, so that is what identifies "me".
 *
 *  Both sides must be present. An unactivated draft employee has no user_id,
 *  and identity hydrates asynchronously — a null-equals-null match would either
 *  show a stranger's draft as "your own record" or flash the self-view callout
 *  on a colleague's page while the session is still loading.
 */
export const isSelfRecord = (
  myUserId?: string | null,
  employeeUserId?: string | null,
): boolean => !!myUserId && !!employeeUserId && employeeUserId === myUserId;
